/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@dazn/dx-rate-my-service-components/loader';
defineCustomElements();
export const RmsButton = /*@__PURE__*/ createReactComponent('rms-button');
export const RmsFeedback = /*@__PURE__*/ createReactComponent('rms-feedback');
export const RmsForm = /*@__PURE__*/ createReactComponent('rms-form');
export const RmsLoader = /*@__PURE__*/ createReactComponent('rms-loader');
export const RmsModal = /*@__PURE__*/ createReactComponent('rms-modal');
export const RmsOverlayLoader = /*@__PURE__*/ createReactComponent('rms-overlay-loader');
export const RmsRating = /*@__PURE__*/ createReactComponent('rms-rating');
export const RmsxDemo = /*@__PURE__*/ createReactComponent('rmsx-demo');
//# sourceMappingURL=components.js.map